import React from 'react';

const EntitiesCard = ({ entities }) => {
  // Check if entities exist and have any data
  const hasEntities = entities && (
    (entities.people && entities.people.length > 0) ||
    (entities.places && entities.places.length > 0) ||
    (entities.organizations && entities.organizations.length > 0) ||
    (entities.other && entities.other.length > 0)
  );

  if (!hasEntities) {
    return (
      <div className="bg-white dark:bg-neutral-950 rounded-lg border border-gray-200 dark:border-neutral-800 p-6">
        <h2 className="text-md font-semibold text-gray-900 dark:text-neutral-100 mb-4">Extracted Entities</h2>
        <div className="text-center py-8">
          <p className="text-gray-600 dark:text-neutral-400 text-sm">No entities extracted yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-neutral-950 rounded-lg border border-gray-200 dark:border-neutral-800 p-4">
      <h2 className="text-md font-semibold text-gray-900 dark:text-neutral-100 mb-4">Extracted Entities</h2>
      <div className="bg-gray-50 dark:bg-neutral-900 rounded p-4 border border-gray-200 dark:border-neutral-700">
        {/* Columnar layout using grid */}
        <div className="grid grid-cols-2 gap-4">
          {entities.people && entities.people.length > 0 && (
            <div>
              <h3 className="text-xs font-semibold text-gray-700 dark:text-neutral-300 uppercase mb-2">People</h3>
              <div className="flex flex-col gap-1">
                {entities.people.map((person, idx) => (
                  <span
                    key={idx}
                    className="px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded text-xs font-medium"
                  >
                    {person}
                  </span>
                ))}
              </div>
            </div>
          )}
          
          {entities.places && entities.places.length > 0 && (
            <div>
              <h3 className="text-xs font-semibold text-gray-700 dark:text-neutral-300 uppercase mb-2">Places</h3>
              <div className="flex flex-col gap-1">
                {entities.places.map((place, idx) => (
                  <span
                    key={idx}
                    className="px-2 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded text-xs font-medium"
                  >
                    {place}
                  </span>
                ))}
              </div>
            </div>
          )}
          
          {entities.organizations && entities.organizations.length > 0 && (
            <div>
              <h3 className="text-xs font-semibold text-gray-700 dark:text-neutral-300 uppercase mb-2">Organizations</h3>
              <div className="flex flex-col gap-1">
                {entities.organizations.map((org, idx) => (
                  <span
                    key={idx}
                    className="px-2 py-1 bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 rounded text-xs font-medium"
                  >
                    {org}
                  </span>
                ))}
              </div>
            </div>
          )}
          
          {entities.other && entities.other.length > 0 && (
            <div>
              <h3 className="text-xs font-semibold text-gray-700 dark:text-neutral-300 uppercase mb-2">Other</h3>
              <div className="flex flex-col gap-1">
                {entities.other.map((item, idx) => (
                  <span
                    key={idx}
                    className="px-2 py-1 bg-gray-200 dark:bg-neutral-700 text-gray-800 dark:text-neutral-200 rounded text-xs font-medium"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EntitiesCard;

